import ShopArticlePagingResultModelBase from '../_generated/modelBases/shop-article-paging-result-model-base';

export default class ShopArticlePagingResultModel extends ShopArticlePagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
